import { c as _c } from "react/compiler-runtime";
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/libs/baseApi.client';
export interface QuizActionSubmitMutationRequest {
  id: number;
  answers: {
    questionId: number;
    answerId: number;
  }[];
}
export interface QuizActionSubmitMutationResponse {
  success?: boolean;
  correctAnswers?: number;
  totalQuestions?: number;
  score?: number;
  rewards?: {
    poe?: number;
    coins?: number;
  };
}
export const useQuizActionSubmitMutation = () => {
  const $ = _c(2);
  const queryCLient = useQueryClient();
  let t0;
  if ($[0] !== queryCLient) {
    t0 = {
      mutationFn: _temp,
      onSuccess(_, t1) {
        const {
          id: id_0
        } = t1;
        queryCLient.invalidateQueries({
          queryKey: ["action-by-id", id_0]
        });
        queryCLient.invalidateQueries({
          queryKey: ["actions-list"]
        });
        queryCLient.invalidateQueries({
          queryKey: ["user"]
        });
      }
    };
    $[0] = queryCLient;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0);
};
async function _temp(t0) {
  const {
    id,
    ...body
  } = t0;
  const response = await api.post(`/quizzes/submit/${id}`, body);
  return response.data;
}